const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_REGIONAL_SELECIONADA = (state,  payload) => {
  state.selecionado = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
  state.paginacao = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_REGIONAL_SELECIONADA,
    ATUALIZAR_PAGINACAO
}